export const TEAM_DATA = [
  {
    name: "Adam Centorrino",
    position: "Founder / Director",
    src: "/images/about-us/Team/Adam.png",
    description: (
      <>
        <p>
          Founder of Incluso Services, Adam Centorrino is a serial entrepreneur and passionate about ‘Creating the World that we Want’. As a values-driven
          leader, Adam is responsible for our service strategy and Incluso Services’ overall organisational direction, Adam has grown Incluso Services from a
          small business to a national provider employing over 50 team members.
        </p>
        <p>
          His passion for people and customer service has only strengthened across his business journey, with Adam personally winning the CSIA Customer Service
          Executive of the Year award in 2022 and 2023. It is this same dedication to people that has led our businesses to be recognised as one of the best
          places to work for many years.
        </p>
        <p>
          He is the co-founder and Executive Director of the Bully Zero Australia Foundation, a group focused on educating workplaces on schools on the
          devastating impacts of bullying. With a strong educational background, Adam also founded the online student portal Bloum in 2019 to help schools
          enhance student health and well-being programs.
        </p>
      </>
    ),
  },
  {
    name: "Edward Boghikian",
    position: "Chief Executive Officer",
    src: "/images/about-us/Team/Edward-Boghikian.jpg",
    description: (
      <>
        <p>
          Edward Boghikian is the Chief Executive Officer of Incluso Services, bringing more than 12 years of experience across the disability and community
          services sector. Passionate about creating services that genuinely improve people&apos;s lives, Edward has held senior executive roles including
          General Manager and CEO positions, where he has successfully led organisational growth, operational excellence and service innovation.
        </p>
        <p>
          A values-driven leader, Edward is committed to building high-performing teams, strong partnerships and person-centred services that deliver meaningful
          outcomes. He is a member of the Australian Institute of Clinical Governance and the Australian Institute of Company Directors, reflecting his
          commitment to strong governance and industry best practice. Under his leadership, Incluso Services continues to strengthen its reputation as a trusted
          provider delivering meaningful outcomes for people, families and communities.
        </p>
      </>
    ),
  },
  {
    name: "Rosie Chiavaro",
    position: "Quality, Risk & Safeguards Manager",
    src: "/images/about-us/Team/Rosie-Chiavaro.jpg",
    description: (
      <>
        <p>
          Rosie Chiavaro brings more than 30 years of experience across government, statutory and not-for-profit sectors to her role as Incluso&apos;s Quality,
          Risk & Safeguards Manager. With qualifications in education, disability, quality auditing and workplace leadership, Rosie is passionate about creating
          strong systems that support accountability, quality and positive outcomes.
        </p>
        <p>
          Known for her practical and collaborative approach, Rosie works closely with leaders and teams to foster continuous improvement, strengthen workplace
          culture and uphold the rights and wellbeing of people with disability.
        </p>
      </>
    ),
  },
  {
    name: "Amy Bryan",
    position: "Operations Manager",
    src: "/images/about-us/Team/Amy-Bryan.jpeg",
    description: (
      <>
        <p>
          Amy Bryan is an experienced operations leader within the disability and community services sector, with extensive experience across Supported
          Independent Living, respite, community access and high-complexity supports within the NDIS environment. Passionate about helping people live
          meaningful and independent lives, Amy leads with compassion, authenticity and a strong commitment to person-centred care.
        </p>
        <p>
          Amy is especially passionate about advocating for people who need a strong voice in their corner and is dedicated to achieving positive outcomes for
          participants and families. In 2019, she received the &quot;Give a Damn&quot; Award for her contributions to youth work and supporting young people
          living with disability to secure opportunities within the IT sector.
        </p>
      </>
    ),
  },
  {
    name: "Kellie Carruthers",
    position: "Head of Connection & Growth",
    src: "/images/about-us/Team/Kellie-Carruthers.jpg",
    description: (
      <>
        <p>
          Kellie brings extensive experience across the disability, community and creative sectors, with a strong passion for building inclusive environments
          where people feel empowered, connected and genuinely supported. As Head of Connection & Growth at Incluso Services, Kellie leads with authenticity and
          innovation, championing person-led practices that strengthen meaningful community participation and improve quality of life for people with
          disability.
        </p>
        <p>
          Throughout her career, Kellie has led impactful community initiatives, developed accessible programs and supported organisational growth through
          strong relationships and values-driven leadership. Known for her creativity, compassion and collaborative approach, Kellie is committed to helping
          shape a disability sector that is empowering, inclusive and centred on respect, dignity and connection.
        </p>
      </>
    ),
  },
  {
    name: "Lisa English",
    position: "General Manager - Finance",
    src: "/images/about-us/Team/Lisa-English.jpg",
    description: (
      <>
        <p>
          Lisa is an accomplished finance executive and business leader with extensive experience driving financial performance, operational excellence, and
          organisational transformation across complex environments. Since joining Incluso Services in early 2026, Lisa has quickly established herself as a
          highly effective and trusted leader, recognised for strengthening financial governance, aligning cross-functional teams, and delivering strong
          operational results.
        </p>
        <p>
          With more than 15 years&apos; experience at BP, Lisa brings deep expertise in financial performance and operational excellence. Known for her
          pragmatic and people-focused leadership style, she builds high-performing teams and is passionate about developing capability, fostering
          accountability, and supporting individuals to perform at their best.
        </p>
      </>
    ),
  },
  // {
  //   name: "Trish Moeke-Parker",
  //   position: "General Manager",
  //   src: teamImageTrish,
  //   description: (
  //     <>
  //       <p>
  //         Trish has worked in the human services sector for over 25 years and is deeply passionate about improving the lives of at-risk and
  //         disadvantaged individuals. Before moving to Melbourne, she developed a strong background in both aged care and disability
  //         services. Trish has held key roles in representing Indigenous issues and supporting education and advocacy efforts in New Zealand.
  //       </p>
  //       <p>
  //         Her passion for supporting NDIS participants emerged when she began assisting young people living in nursing homes with their
  //         planning meetings. With her extensive experience and success as a Business Development Manager, Trish is dedicated to helping the
  //         Incluso community thrive and live their best lives.
  //       </p>
  //       <p>
  //         Outside of work, Trish is a proud Māori mother of four, married to an incredible husband. She loves traveling for quality family
  //         time, enjoys skiing, and is an avid reader.
  //       </p>
  //     </>
  //   ),
  // },
  // {
  //   name: "Hannah Chasen",
  //   position: "Business Manager",
  //   src: "/images/about-us/Team/Hannah.png",
  //   description: (
  //     <>
  //       <p>
  //         Hannah is a dynamic professional with a unique blend of expertise in both business and law. As a skilled business manager, she has a proven track
  //         record of driving growth, enhancing operational efficiency, and fostering innovation. Hannah started her career working in the audiology industry for
  //         five years where she worked with clients who were NDIS, HSP and DVA funded.
  //       </p>
  //     </>
  //   ),
  // },
  // {
  //   name: "Peng Wang",
  //   position: "Finance Manager",
  //   src: "/images/about-us/Team/Dennis.png",
  //   description: (
  //     <>
  //       <p>
  //         Peng, in his role oversees and manages the financial operations of Incluso Services. He is responsible for financial planning, budgeting, forecasting,
  //         analysis, and reporting, ensuring compliance with accounting standards, regulatory requirements, and internal controls. Additionally, Peng provides
  //         financial insights and recommendations to senior management to support strategic decision-making.
  //       </p>
  //       <p>
  //         Peng is passionate about driving financial performance and adding value through effective financial management. He thrives on analysing complex
  //         financial data, identifying areas of improvement, and implementing strategies to optimise financial outcomes. Moreover, he is enthusiastic about
  //         fostering strong cross-functional relationships and collaborating with stakeholders to achieve shared goals.
  //       </p>
  //     </>
  //   ),
  // },
  // {
  //   name: "Sam Daoud",
  //   position: "Community Engagement Manager",
  //   src: "/images/about-us/Team/Sam.png",
  //   description: (
  //     <>
  //       <p>{`Sam is an experienced Community Engagement Manager with extensive expertise in the NDIS sector, with a strong background as an Authorised Program Officer (APO), Sam has worked closely with
  //         families, hospitals and clinics to support NDIS participants in accessing the services they need. His role involves fostering meaningful connections within the community, ensuring compliance
  //         with industry regulations, and advocating for participants well being.`}</p>
  //       <p>{`Passionate about Inclusion and quality care, Sam is dedicated to creating positive outcomes for individuals with disabilities and strengthening support networks across the sector.`}</p>
  //     </>
  //   ),
  // },
  // {
  //   name: "Frank Bifera",
  //   position: "Business Development Manager",
  //   src: teamImageFrank,
  // },
]
